import React from 'react';
import { Paper } from '@c2fo/liquidity';
import { usePageFeature } from './usePageFeature';
import type { PageFlagName } from './pageFlags';

export interface ComingSoonRouteProps {
  /** Split.io flag name for this route. When treatment is 'on', children render; otherwise Coming Soon page. */
  splitName: PageFlagName;
  children: React.ReactElement;
}

const COMING_SOON_MESSAGE = 'This page is coming soon.';

/**
 * Wraps a route's element: when the page flag is off for the current user, shows a "Coming soon" view
 * (Liquidity Paper) instead of the real page. Use with ComingSoonNavLink so nav shows the link disabled
 * with tooltip; this handles direct URL access.
 */
export const ComingSoonRoute: React.FC<ComingSoonRouteProps> = ({ splitName, children }) => {
  const { enabled } = usePageFeature(splitName);

  if (enabled) {
    return children;
  }

  return (
    <div
      className="flex flex-col items-center justify-center min-h-[50vh] px-4"
      data-testid={`coming-soon-route-${splitName}`}
    >
      <Paper className="max-w-md p-8 text-center">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">Coming soon</h2>
        <p className="text-gray-600">{COMING_SOON_MESSAGE}</p>
      </Paper>
    </div>
  );
};
